// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__22Lnh","edit":"style_edit__xOHWT","close":"style_close__3g_AH","icon":"style_icon__2V5HQ","abortBtn":"style_abortBtn__Yy1N4"};